import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { Subscription } from 'rxjs';
import _ from 'lodash';
import { WINDOW } from '../../data/storage';
import { Storage } from 'src/app/models/storage';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-add-window',
  templateUrl: './add-window.component.html',
})
export class AddWindowComponent implements OnInit {
  subscription: Subscription;
  storage: Storage;
  accordion: any;

  constructor(
    private storageService: StorageService,
    private cdRef: ChangeDetectorRef,
    private accordionService: AccordionService,
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;
    this.accordion = this.accordionService.accordion;
    this.storageSubscription();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;
    });
  }

  handleAddWindow() {
    const storage = _.cloneDeep(this.storageService.storage);
    let newWindow = _.cloneDeep(WINDOW);

    // ustawienie, zeby nowo dodane okno pojawialo sie rozwiniete
    const accordion = this.accordion;
    accordion.window = storage.windows.length;
    this.accordionService.accordion = accordion;
    
    // do zmiany jesli pojawi sie usuwanie okien
    newWindow.id = storage.windows.length + 1;
    storage.windows.push(
      newWindow
    );
    this.cdRef.detectChanges();

    this.storageService.storage = storage;
  }
}
